// extracted by mini-css-extract-plugin
export default {"ProjectContainer":"ProjectContainer_ProjectContainer__eb22H","Projects_head":"ProjectContainer_Projects_head__U2oxO","Projects":"ProjectContainer_Projects__+JXjK"};